<template>
    <div id="mail-composer">
        <div class="title-wrapper" v-if="!selectedMailItem">
            <div class="title">{{ $t("mail.composeNewEmail") }}</div>
            <div class="close-button" @click="closeEditor">
                <span class="material-icons"> close </span>
            </div>
        </div>
        <div class="email-editor">
            <div class="body">
                <div class="email-editor">
                    <MailAddressList
                        label="from"
                        @selectedMembers="(v) => (selectedFromMember = v)"
                        :defaultFromMember="defaultFromMember"
                    />
                    <MailAddressList
                        label="to"
                        @selectedMembers="(v) => (selectedToMembers = v)"
                        @selectedCcOrBcc="(value) => changeSelectedCcOrBcc(value)"
                        :defaultToMember="defaultToMember"
                    />
                    <MailAddressList label="cc" @selectedMembers="(v) => (selectedCCMembers = v)" v-if="selectedCC" />
                    <MailAddressList
                        label="bcc"
                        @selectedMembers="(v) => (selectedBCCMembers = v)"
                        v-if="selectedBCC"
                    />
                    <div class="subject-container" v-if="!selectedMailItem">
                        <div class="subject">{{ $t("message.subject") }}:</div>
                        <a-input v-model="subject" class="subject-input" />
                    </div>
                </div>
                <div style="position: relative">
                    <quill-editor
                        style="max-height: 14%"
                        ref="myQuillEditor"
                        id="chat-editor"
                        @change="onEditorChange($event)"
                        :options="editorOption"
                        v-model="replyContentClone"
                    />
                </div>
                <div class="placeholder">
                    <div class="label">
                        Placeholders
                        <span class="material-icons" style="font-size: 16px">help</span>
                    </div>
                    <div class="variables">
                        <div class="action-button" @click="aiCopilot = { type: 'fix-grammar' }">
                            <div class="material-icons">emoji_objects</div>
                        </div>
                        <AICopilot
                            v-if="aiCopilot"
                            @close="aiCopilot = null"
                            :type="'mail'"
                            :mailText="replyContentClone"
                            :mailDetails="firstMailBodyText"
                            @change="replyContentClone = $event"
                        />
                    </div>
                </div>
                <div class="attachments" v-if="attachments.length > 0">
                    <div class="attachment" v-for="(attachment, index) of attachments">
                        <div class="left">
                            <span class="material-icons" style="font-size: 16px">attach_file</span>
                            <span class="filename">{{ attachment.file.name }}</span>
                            <span class="size">({{ attachment.newSize }} kB)</span>
                        </div>
                        <span
                            v-if="fileLoading === 100"
                            class="material-icons"
                            style="font-size: 16px; cursor: pointer"
                            @click="deleteAttachment(index)"
                            >delete</span
                        >
                        <span v-else>{{ fileLoading }}%</span>
                    </div>
                </div>
                <div class="footer">
                    <div class="left">
                        <button class="attache_file_btn" @click="selectFile">
                            <div class="material-icons" style="font-size: 20px; color: black">attach_file</div>
                            {{ $t("mail.attacheFiles") }}
                        </button>
                    </div>
                    <div class="right">
                        <button class="cancel" @click="closeEditor">{{ $t("wp.cancel") }}</button>
                        <button
                            class="send"
                            @click="sendMail"
                            :class="!sendButtonEnable ? 'disable' : ''"
                            :disabled="!sendButtonEnable"
                        >
                            {{ $t("wp.send") }}
                            <div class="material-icons" style="font-size: 20px; margin-left: 5px; color: white">
                                send
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import { sendSocketMessage } from "../../../utils/socketStream";
import { getExtensionFromFileName } from "../../../utils/utils";
import { uploadAsset } from "../../../api/assetUpload";
import mimeTypes from "../../../components/util/mimeTypes";
import axios from "axios";
import { generateUUID } from "../../../utils/session";
import Avatar from "vue-avatar";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";
import MailAddressList from "./MailAddressList.vue";
import AICopilot from "../../../components/popup-chat/chat-window/ChatMessageArea/components/AICopilot.vue";
import _ from "lodash";

const log = log2("MailComposer");
export default {
    name: "MailComposer",
    components: {
        AgentAvatar,
        Avatar,
        MailAddressList,
        AICopilot,
    },
    props: {
        mailDetails: {
            type: Array,
            default: [],
        },
        replyContent: "",
        isForward: {
            type: Boolean,
            default: false,
        },
        isVisitorDetail: {
            type: Boolean,
            default: false,
        },
        isNewMail: {
            type: Boolean,
            default: false,
        },
        isUserMailDetail: {
            type: Boolean,
            default: false,
        },
        selectedMailItem: {},
        mailDetailPage: {},
        defaultTo: {
            type: String,
        },
    },
    data() {
        return {
            aiCopilot: null,
            subject: "",
            contentHtml: "",
            contentText: "",
            selectedCC: false,
            selectedBCC: false,
            emailName: "",
            attachments: [],
            keyboardBindings: [],
            selectedToMembers: [],
            selectedCCMembers: [],
            selectedBCCMembers: [],
            assetIds: [],
            mailAddressOptions: [],
            optionType: "",
            fileLoading: 0,
            editorOption: {
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        ["link"],
                    ],
                },
            },
            hoverMailAddressOption: "",
            sendButtonEnable: true,
            selectedFromMember: [],
            userEmailAddress: "",
            defaultFromMember: [],
            replyContentClone: "",
            defaultToMember: [],
            senderName: "",
            departmentMailAddresses: [],
        };
    },
    created() {
        if (this.defaultTo) {
            this.defaultToMember = [this.defaultTo];
        }
    },
    computed: {
        ...mapState({
            selectedDepartment: (state) => state.mail.selectedDepartment,
            selectedMenu: (state) => state.mail.selectedMenu,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            exportContent: (state) => state.mail.exportContent,
            selectedVisitor: (state) => state.visitor.selectedVisitor,
            users: (state) => state.user.users.data,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            selectedMailId: (state) => state.mail.selectedMailId,
        }),
        ...mapGetters({}),
        firstMailBodyText() {
            return this.mailDetails.length > 0 ? this.mailDetails[0].body_text : "";
        },
    },
    methods: {
        ...mapActions({
            getVisitor: "visitor/getVisitor",
            mailVerification: "mail/mailVerification",
            getUserEmailAddress: "mail/getUserEmailAddress",
            getMailAddressByToList: "mail/getMailAddressByToList",
            createVisitorAndMailAddressMulti: "mail/createVisitorAndMailAddressMulti",
            getMailSignature: "mail/getMailSignature",
            getSenderMailAddressesByInput: "mail/getSenderMailAddressesByInput",
            getDepartmentMailAddresses: "mail/getDepartmentMailAddresses",
        }),
        ...mapMutations({
            SELECTED_NEW_MAIL: "mail/SELECTED_NEW_MAIL",
        }),
        changeSelectedCcOrBcc(value) {
            if (value === "cc") {
                this.selectedCC = true;
            } else if (value === "bcc") {
                this.selectedBCC = true;
            }
        },
        onEditorChange({ quill, html, text }) {
            this.contentHtml = html;
        },
        closeEditor() {
            this.SELECTED_NEW_MAIL(false);
            this.$emit("closeEditor");
        },
        checkEmail(email) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test(email);
        },
        async sendMail() {
            this.sendButtonEnable = false;

            let mailAddress = await this.getSenderMailAddressesByInput({
                userId: this.user._id,
                data: this.selectedFromMember[0],
            });

            mailAddress = mailAddress.map((item) => item.mail);

            if (!mailAddress.includes(this.selectedFromMember[0])) {
                this.$message.error(this.$t("mail.couldNotUserMail"));
                this.sendButtonEnable = true;
                return;
            }

            if (
                !this.selectedFromMember[0] ||
                this.selectedFromMember[0].length === 0 ||
                this.selectedToMembers.length === 0
            ) {
                this.$message.error(this.$t("mail.mailAddressReq"));
                this.sendButtonEnable = true;
                return;
            }

            const mailList = [
                ...this.selectedCCMembers,
                ...this.selectedBCCMembers,
                ...this.selectedToMembers,
                ...this.selectedFromMember,
            ];

            console.log("mailList before...", mailList);
            mailList.map((x) => {
                if (!this.checkEmail(x)) {
                    this.$message.error(this.$t("mail.emailAddressInvalid"));
                    this.sendButtonEnable = true;
                    return;
                }
            });
            console.log("mailList after...", mailList);

            await this.createVisitorAndMailAddressMulti({
                siteId: this.site_id,
                mailList,
                type: "visitor",
            });

            console.log("createVisitorAndMailAddressMulti after...");

            const regex = /(<([^>]+)>)/gi;
            this.contentText = this.contentHtml.replace(regex, "");

            const generateThreadId = () => {
                let generateUuid = generateUUID();
                const uuidSplitList = generateUuid.split("-");
                generateUuid = uuidSplitList[uuidSplitList.length - 1];
                return generateUuid;
            };

            console.log("getMailAddressByToList before...", mailList);

            const mailAddresses = await this.getMailAddressByToList({ mailList });

            console.log("getMailAddressByToList after...", mailAddresses);

            let ref_visitor_ids = mailAddresses.filter((item) => item.type === "visitor");
            ref_visitor_ids = _.uniqBy(ref_visitor_ids, "mail");

            const ref_user_ids = mailAddresses.filter((item) => item.type === "user").map((item) => item.user);
            const ref_department_ids = mailAddresses
                .filter((item) => item.type === "department")
                .map((item) => item.department);

            const visitorMails = ref_visitor_ids.map((item) => item.mail);
            const newToList = this.selectedToMembers.filter((item) => {
                return !visitorMails.includes(item);
            });

            const departmentId =
                this.selectedDepartment !== null
                    ? this.departmentMailAddresses.find((item) => item.mail === this.selectedDepartment)?.department._id
                    : null;
            if (!!this.selectedDepartment && !departmentId) {
                this.$message.error(this.$t("mail.departmentIsNotValid"));
                this.sendButtonEnable = true;
                return;
            }

            if (this.selectedMenu === "department") {
                const result = await this.mailVerification({
                    userId: this.user._id,
                    departmentId,
                    mail: this.selectedFromMember[0],
                });
                if (!result) {
                    this.$message.error(this.$t("mail.mailSendNotValid"));
                    this.sendButtonEnable = true;
                    return;
                }
            }

            const replyToMessageId = !!this.isForward
                ? null
                : !!this.selectedMailItem
                ? this.selectedMailItem.messageId
                : this.mailDetails.length > 0
                ? this.mailDetails[this.mailDetails.length - 1].messageId
                : "";

            const subject = !!this.selectedMailItem
                ? "Re: " + this.selectedMailItem.subject
                : this.mailDetails.length > 0
                ? this.mailDetails[this.mailDetails.length - 1].subject
                : this.subject;

            const threadId = !!this.isForward
                ? generateThreadId()
                : !!this.isNewMail
                ? generateThreadId()
                : this.mailDetails.length > 0
                ? this.mailDetails[0].thread_id
                : generateThreadId();

            console.log("exportContent..", {
                exportContent: this.exportContent,
                ref_visitor_ids,
                ref_user_ids,
                contentHtml: this.contentHtml,
            });
            this.$message.warning("Mail Gönderiliyor...", 3);

            console.log("send Mail this.allMailAddresses...", this.allMailAddresses);

            if (ref_visitor_ids.length !== 0) {
                ref_visitor_ids.map((visitor) => {
                    const data = {
                        sender: this.selectedFromMember[0] ? this.selectedFromMember[0] : this.defaultFromMember[0],
                        to_list: [...newToList, visitor.mail],
                        cc_list: this.selectedCCMembers,
                        bcc_list: this.selectedBCCMembers,
                        ref_user_ids: [...ref_user_ids, this.user._id],
                        ref_department_ids,
                        ref_visitor_id: visitor.visitor,
                        subject: subject,
                        body_html: this.contentHtml,
                        body_text: this.contentText,
                        replyToAddresses: [],
                        files: this.attachments,
                        attachments: this.assetIds,
                        fileNames: this.attachments.map((file) => file.file.name),
                        thread_id: threadId,
                        replay_to_message_id: replyToMessageId,
                        senderName: this.senderName,
                    };
                    sendSocketMessage("email send", {
                        siteId: this.site._id,
                        userId: this.user._id,
                        data,
                    });
                    this.$emit("closeEditor");
                    this.$emit("newMailDetail", [data]);
                });
            } else {
                const data = {
                    sender: this.selectedFromMember[0] ? this.selectedFromMember[0] : this.defaultFromMember[0],
                    to_list: this.selectedToMembers,
                    cc_list: this.selectedCCMembers,
                    bcc_list: this.selectedBCCMembers,
                    ref_user_ids: [...ref_user_ids, this.user._id],
                    ref_department_ids,
                    ref_visitor_id: "",
                    subject: subject,
                    body_html: this.contentHtml,
                    body_text: this.contentText,
                    replyToAddresses: [],
                    files: this.attachments,
                    attachments: this.assetIds,
                    fileNames: this.attachments.map((file) => file.file.name),
                    thread_id: threadId,
                    replay_to_message_id: replyToMessageId,
                    senderName: this.senderName,
                };
                sendSocketMessage("email send", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    data,
                });
                this.$emit("newMailDetail", [data]);
                this.$emit("closeEditor");
            }
        },
        deleteAttachment(index) {
            this.attachments = this.attachments.filter((attachment, i) => i !== index);
            this.assetIds = this.assetIds.filter((assetId, i) => i !== index);
        },
        async selectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute("multiple", "multiple");
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                for (let i = 0; i < fileEl.files.length; i++) {
                    if (file.size <= 20 * 1024 * 1024) {
                        let uploadFile = {
                            fileNumber: Math.random(),
                            finished: false,
                            percent: 0,
                            failed: false,
                        };
                        await this.uploadFile(fileEl.files[i], uploadFile);
                    } else {
                        log.warn("input is not suitable for send");
                        this.$toasted.error(this.$t("message.assetOversizeWithExt"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                    }
                }
            };
            fileEl.click();
        },
        async uploadFile(file, uploadFile) {
            this.fileLoading = 0;
            const newSize = (file.size / 100).toFixed(2);
            const fileId = this.attachments.length + 1;
            this.attachments.push({ file, newSize, fileId });
            const fileType = getExtensionFromFileName(file.name);
            let path = `${this.site._id}/email/attachments/`;

            console.log("uploadFile path...", file);
            let { data } = await uploadAsset({
                path,
                mime: file.type,
                ext: mimeTypes[file.type] || fileType || "supsis",
                name: file.name,
                size: file.size,
                type: "mail",
            });
            this.assetIds.push(data.asset.id);

            console.log("uploadFile data...", data);

            if (file.size <= 10 * 1024 * 1024) {
                await axios({
                    method: data.method,
                    url: data.url,
                    data: file,
                    headers: {
                        "Content-Type": file.type,
                    },
                    onUploadProgress: await function (progressEvent) {
                        this.fileLoading = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                    }.bind(this),
                }).then((res) => {
                    console.log("created asset res", res);
                });
            } else {
                log.warn("input is not suitable for send");
                this.$toasted.error(this.$t("message.assetOversize"), {
                    duration: 3000,
                    position: "bottom-center",
                });
            }
        },
        getUserMailAddress() {
            return !!this.allMailAddresses && this.allMailAddresses.length > 0
                ? this.allMailAddresses.filter(
                      (email) => email.type === "user" && !!email.user && email.user._id === this.user._id
                  )[0]?.mail
                : "";
        },
        getSelectedMailAddress() {
            console.log("getDepartmentMailAddress...", this.allMailAddresses);
            return !!this.allMailAddresses && this.allMailAddresses.length > 0
                ? this.allMailAddresses.filter(
                      (email) => email.type === "department" && email.department === this.$route.params.id
                  )[0]?.mail
                : this.allMailAddresses.filter(
                      (email) => email.type === "user" && email._id === this.$route.params.id
                  )[0]?.mail;
        },
    },

    async mounted() {
        this.departmentMailAddresses = await this.getDepartmentMailAddresses(this.user._id);
        console.log("mailComposer departmentMailAddresses ", this.departmentMailAddresses);

        const department = this.selectedDepartment
            ? this.departmentMailAddresses.filter((x) => x.mail === this.selectedDepartment)
            : [];

        const departmentName = department.length > 0 ? department[0].department.languageContent[0].name : "";

        this.senderName = this.selectedMenu === "department" ? departmentName : this.user.name;

        //this.replyContentClone = this.replyContent;

        //this.userEmailAddress = await this.getUserEmailAddress(this.user._id);
        this.userEmailAddress = this.allMailAddresses.filter(
            (email) =>
                email.type === "user" && !!email.user && email.user._id === this.user._id && email.idDefault === true
        )[0];

        this.$set(
            this.defaultFromMember,
            0,
            this.selectedMenu === "department"
                ? this.selectedDepartment
                : this.selectedMailId || this.replyContent !== ""
                ? this.allMailAddresses.filter((email) => email._id === this.selectedMailId)[0]?.mail
                : !!this.isNewMail
                ? this.userEmailAddress.mail
                : !!this.getSelectedMailAddress() && this.getSelectedMailAddress().length > 0
                ? this.getSelectedMailAddress()
                : !!this.isVisitorDetail
        );

        this.selectedFromMember = this.defaultFromMember;

        // selectedMenu -> My --> sender
        // selectedMenu -> Sent && !!replay_to_message_id --> sender
        // selectedMenu -> Sent && !replay_to_message_id --> to_list
        if (!!this.mailDetailPage && Object.keys(this.mailDetailPage).length > 0) {
            const mailAddress =
                this.selectedMailItem.to_list === this.mailDetailPage.mail
                    ? this.selectedMailItem.sender
                    : this.selectedMailItem.to_list;
            this.$set(this.defaultToMember, 0, mailAddress);
        } else if (!!this.selectedMailItem && !this.isNewMail) {
            this.$set(
                this.defaultToMember,
                0,
                this.selectedMailItem.to_list &&
                    this.selectedMenu === "Sent" &&
                    !this.selectedMailItem.replay_to_message_id
                    ? this.selectedMailItem.to_list
                    : this.selectedMenu === "Sent" &&
                      !!this.selectedMailItem.replay_to_message_id &&
                      this.getUserMailAddress() === this.selectedMailItem.sender
                    ? this.selectedMailItem.to_list
                    : this.selectedMenu === "Sent" &&
                      !!this.selectedMailItem.replay_to_message_id &&
                      this.getUserMailAddress() !== this.selectedMailItem.sender
                    ? [this.selectedMailItem.sender]
                    : !!this.selectedMailItem &&
                      this.selectedMenu === "My" &&
                      this.getUserMailAddress() === this.selectedMailItem.sender
                    ? this.selectedMailItem.to_list
                    : !!this.selectedMailItem &&
                      this.selectedMenu === "My" &&
                      this.getUserMailAddress() !== this.selectedMailItem.sender
                    ? [this.selectedMailItem.sender]
                    : this.selectedMenu === "department" && !this.selectedMailItem.replay_to_message_id
                    ? this.selectedMailItem.to_list
                    : this.selectedMenu === "department" && !!this.selectedMailItem.replay_to_message_id
                    ? [this.selectedMailItem.sender]
                    : []
            );
        } else if (!!this.isNewMail && !!this.$route.params.visitorId) {
            await this.getVisitor(this.$route.params.visitorId).then((response) => {
                this.$set(this.defaultToMember, 0, [response.data.email]);
            });
        } else if (!!this.isUserMailDetail && !!this.selectedMailItem) {
            this.$set(this.defaultToMember, 0, this.selectedMailItem.to_list);
        } else if (!!this.isNewMail && !this.$route.params.visitorId) {
            this.selectedToMembers = this.defaultToMember[0];
        } else if (
            Object.keys(this.selectedVisitor).length > 0 &&
            this.selectedVisitor.email !== "" &&
            !this.isNewMail
        ) {
            this.$set(this.defaultToMember, 0, [this.selectedVisitor.email]);
            this.selectedToMembers = this.defaultToMember[0];
        }
        this.selectedToMembers = this.defaultToMember[0];

        const signature = await this.getMailSignature({ mailAddress: this.selectedFromMember[0] });
        if (!!signature && !!signature.isAutoAdd) {
            this.replyContentClone = "<br><br>" + signature.html + "<br><br>" + this.contentHtml;
        }
    },

    watch: {
        selectedFromMember: {
            handler: function (val) {
                const found = this.replyContentClone.match(/(<p><br><\/p><p><br><\/p>)(.*?)(<p><br><\/p>)/);
                console.log("found..", found);

                if (!found) {
                    this.getMailSignature({ mailAddress: this.selectedFromMember[0] }).then((signature) => {
                        if (!!signature && !!signature.isAutoAdd) {
                            console.log("this.replyContentClone...", this.replyContentClone);
                            this.replyContentClone = this.replyContentClone.replace(
                                /(<p><br><\/p><p><br><\/p>)(.*?)(<p><br><\/p>)/,
                                `$1${signature.html}$3`
                            );
                        }
                    });
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
pre.ql-syntax {
    background-color: unset !important;
    color: black !important;
}

#mail-composer {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    overflow: scroll;

    .ql-toolbar.ql-snow {
        background-color: #f9fafb;
    }

    .ant-input:focus {
        box-shadow: none;
    }

    .ql-toolbar.ql-snow + .ql-container.ql-snow {
        height: 300px;
    }

    .title-wrapper {
        padding: 10px 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 20px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .close-button {
            cursor: pointer;

            &:hover {
                background-color: #e4e4e4;
                border-radius: 3px;
            }
        }
    }

    .email-editor {
        width: 100%;

        .body {
            display: flex;
            flex-direction: column;
            padding: 20px;

            .template-btn {
                border: none;
                display: flex;
                align-items: center;
                font-size: 12px;
                cursor: pointer;
            }

            .email-editor {
                width: 100%;
                background: #fff;
                display: flex;
                flex-direction: column;
                border: 1px solid #d0d9dd;
                border-top-right-radius: 5px;
                border-top-left-radius: 5px;

                .to-container {
                    display: flex;
                    border-bottom: 1px solid #d0d9dd;
                    justify-content: space-between;
                    height: 40px;

                    .mail-options {
                        z-index: 999999;
                        color: black;
                        padding-top: 10px;
                        width: 300px;
                        border-radius: 5px;
                        display: inline-table;
                        margin-left: -1380px !important;
                        margin-top: 40px;
                        background: #ffffff !important;
                        border: 0.5px solid #cfcfcf;
                        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12),
                            0 9px 28px 8px rgba(0, 0, 0, 0.05);

                        .close-options {
                            display: flex;
                            cursor: pointer;
                            justify-content: end;
                            margin-right: 10px;
                            margin-bottom: -27px;
                        }

                        .mailAddressOptionsLabels {
                            font-weight: 500;
                            font-size: larger;
                            margin: 5px 0 5px 0;
                        }

                        .mail-option-hover {
                            &:hover {
                                cursor: pointer;
                                background: #d5d2d2;
                                border-radius: 5px;
                                padding: 5px;
                            }
                        }

                        .mail-option {
                            cursor: pointer;
                            background: #d5d2d2;
                            border-radius: 5px;
                        }

                        .avatar {
                            margin-right: 10px;
                            vertical-align: middle;
                            width: 30px;
                            height: 30px;
                            border-radius: 25px;
                            font-family: Helvetica, Arial, sans-serif;
                            background-color: #8d5cc6;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            .avatar-name {
                                font-size: medium;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    .left {
                        display: flex;
                        width: calc(100% - 150px);
                        flex-wrap: wrap;
                        grid-gap: 5px;
                        gap: 5px;
                        align-items: center;
                        width: auto;

                        .to {
                            padding-left: 10px;
                            align-items: center;
                            display: flex;
                            justify-content: center;
                        }

                        .mail-input {
                            border: none;
                        }

                        .selected-user-item {
                            background-color: #3c92de;
                            padding: 5px;
                            border-radius: 10px;
                            display: flex;
                            align-items: center;
                            margin-left: 5px;
                            margin-right: 0px;
                            color: white;
                            height: 30px;

                            .closeIcon {
                                font-size: 15px;
                                margin-left: 5px;
                                color: white;
                                cursor: pointer;
                            }
                        }
                    }

                    .buttons {
                        width: 70px;
                        display: flex;
                        grid-gap: 5px;
                        gap: 5px;
                        justify-content: flex-end;
                        margin-right: 5px;

                        .item {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            color: black;
                            justify-content: center;

                            &:hover {
                                background-color: #e4e4e4;
                            }
                        }
                    }
                }

                .subject-container {
                    height: 40px;
                    display: flex;
                    align-items: center;

                    .subject {
                        padding-left: 10px;
                    }

                    .subject-input {
                        border: none;
                    }
                }
            }

            .placeholder {
                height: 60px;
                background: #fff;
                display: flex;
                grid-gap: 5px;
                gap: 5px;
                width: 100%;
                padding: 10px;
                border: 1px solid #d0d9dd;

                .label {
                    display: flex;
                    grid-gap: 5px;
                    gap: 5px;
                    justify-content: center;
                    align-items: center;
                    color: #5a5f72;
                }

                .variables {
                    width: 100%;
                    display: flex;
                    grid-gap: 5px;
                    gap: 5px;
                    align-items: center;
                    justify-content: flex-end;
                }
            }

            .attachments {
                display: flex;
                flex-direction: column;

                .attachment {
                    padding: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 1px solid #d0d9dd;

                    .left {
                        display: flex;
                        grid-gap: 5px;
                        gap: 5px;

                        .filename {
                            color: var(--color-text-primary-active);
                            cursor: pointer;
                            display: -webkit-box;
                            overflow: hidden;
                        }

                        .size {
                            color: var(--color-text-low-default);
                            font-size: 13px;
                        }
                    }
                }
            }

            .footer {
                display: flex;
                justify-content: space-between;
                grid-gap: 10px;
                gap: 10px;
                background: #f3f5f6;
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
                border: 1px solid #d0d9dd;
                padding: 10px;

                .left {
                    .attache_file_btn {
                        border: none;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: black;
                    }
                }

                .right {
                    display: flex;

                    .cancel {
                        border: none;
                        font-weight: 500;
                        line-height: 1.75;
                        margin-right: 5px;
                    }

                    .send {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-radius: 5px;
                        color: #fff;
                        background-color: #009688;
                        border: none;
                        padding: 4px 10px;
                        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                            0px 1px 5px 0px rgba(0, 0, 0, 0.12);

                        &.disable {
                            background-color: #e4e4e4;
                            color: #9e9e9e;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }

    .action-button {
        background: var(--color-bg-neutral-default);
        border: 1px solid var(--border-neutral-default);
        border-radius: 40px;
        line-height: 0;
        cursor: pointer;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;

        &.voice-speech {
            animation-name: voiceSpeakAnimation;
            animation-duration: 1s;
            animation-iteration-count: infinite;
        }

        &.primary {
            background: var(--primary-default-button-color) !important;
            border: 1px solid var(--primary-default-button-color) !important;

            .material-icons {
                color: white !important;
            }

            svg > g > path {
                fill: white !important;
            }
        }

        &.send {
            .material-icons {
                font-size: 18px;
            }
        }

        .material-icons {
            color: var(--primary-default-button-color);
        }

        svg > g > path {
            fill: var(--primary-default-button-color) !important;
        }
    }
}
</style>
